import { render, staticRenderFns } from "./CollegeWork.vue?vue&type=template&id=bee50264&scoped=true"
import script from "./CollegeWork.vue?vue&type=script&lang=ts"
export * from "./CollegeWork.vue?vue&type=script&lang=ts"
import style0 from "./CollegeWork.vue?vue&type=style&index=0&id=bee50264&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee50264",
  null
  
)

export default component.exports